import {engineApi} from "../../../api/engine-api";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {mapToRoutingMonthly} from "../../../data/mapper/routing-log-mapper";

export const setRoutingSummaryDispatch = createAsyncThunk(
    'routing/fetchRoutingLogsMonthly',
    async (_, thunkAPI) => {
        try {
            const response = await engineApi.getRoutingLogsMonthly();
            return mapToRoutingMonthly(response.data);
        } catch (error) {
            return thunkAPI.rejectWithValue({error: ""});
        }
    }
);
